import React, {useState, useEffect, useContext} from "react";
import {Link} from "react-router-dom";
import AuthContext from "../../context/auth/authContext";
import {useAlert} from 'react-alert'
import Swal from 'sweetalert2'
import {useParams} from 'react-router-dom';


const AccountActivationScreen = () => {

    const {auth, activate_account, clearAlert} = useContext(AuthContext);
    let [loading, setHide_loading] = useState("d-flex");
    let [page_loading, setPage_loading] = useState(true);

    const alert = useAlert()
    let token = useParams().token

    useEffect(async () => {
        async function fetch_data(token) {
            return activate_account(token)
        }

        if (page_loading) {
            setPage_loading(false);

            fetch_data(token).then(res => {

                setHide_loading("d-none")
                if (res.request.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: "Account activation successful",
                        footer: '<a href="/">Go to homepage</a>'
                    })

                } else if (res.request.status === 203) {
                    Swal.fire({
                        icon: 'error',
                        title: JSON.parse(res.request.response).message,
                        footer: '<a href="/">Go to homepage</a>'
                    })

                }
            })
        }


        if (auth.message.msg !== "") {
            alert.show(
                auth.message.msg, auth.message.msg_options
            )
            clearAlert()
        }
    }, [auth.message.msg])


    return (
        <div className="login-sect">
            <div className="split-grid-sect">
                <div className="split-grid-2 h-100 bg-white">
                    <div className="login-details-show d-flex justify-content-center align-items-center h-100">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 mx-auto text-center">
                                    <h4 className="make-bold">Account activation</h4>
                                    <div className={loading + " justify-content-center"}>
                                        <div className="spinner-grow text-success" role="status"
                                             style={{width: "6rem", height: "6rem"}}>
                                        </div>
                                    </div>
                                    <p className={loading + " justify-content-center"}>Activating account</p>
                                    <Link to="/">Go to homepage</Link>
                                    <p>
                                        <Link to="/login">Login</Link>
                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="split-grid-1 bg-primary add-bg-image position-relative d-none d-xl-block d-lg-block">
                    <div id="carouselAdminIndicators" className="carousel slide" data-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <div className="add-overlay"></div>
                                <div className="img-holder-10">
                                    <img src="/images/banner-3.jpg" className="d-block w-100 ob-fit vh-100-2"
                                         alt="..."/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

}

export default AccountActivationScreen;
